import { render, staticRenderFns } from "./MaxWidthContainer.vue?vue&type=template&id=6673236b&scoped=true&"
import script from "./MaxWidthContainer.vue?vue&type=script&lang=js&"
export * from "./MaxWidthContainer.vue?vue&type=script&lang=js&"
import style0 from "./MaxWidthContainer.vue?vue&type=style&index=0&id=6673236b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673236b",
  null
  
)

export default component.exports